<!-- 
    Defaults to number
 -->
<script>
    export let
        type = '',
        rows = '',
        classname = '',
        optclass = '',
        istext = false,
        nameval = '',
        onSelect,
        selected = '',
        options = [],
        innerval = '',
        error = '',
        placeholder = '',
        tlClass = false

    $: {
        innerval = nameval // !istext ? helpers.commatize(nameval) : nameval;
    }

</script>

<style>
     .error {
        color: red;
    }
    .select {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        /* Remove default arrow */
        /* background-image: url(...); */
        background-image: url("data:image/svg+xml;utf8,<svg fill='red' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
        background-repeat: no-repeat;
        /* Add custom arrow */
        border: none;
        /* border-bottom: 0.5px solid #ff3e00; */

        font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans","Liberation Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";

        color: #ff3e00;
        text-transform: uppercase;
        font-size: 2em;
        font-weight: 100;
        text-align: center;
        text-align-last: center;
    }

    .select.caret {
        background-position-x: 65%;
        background-position-y: 50%;
    }

    @media only screen and (max-width: 900px) {
        .select.caret {
            font-size: 1em;
            background-image: url("data:image/svg+xml;utf8,<svg fill='red' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
            background-repeat: no-repeat;
            background-position-x: 100%;
            background-position-y: 50%;
        }
    }

    .select::-ms-expand {
        display: none;
        /* Hide the default arrow in Internet Explorer 10 and Internet Explorer 11 */
    }
</style>

<div style="display: flex; flex-direction: column;">


    {#if type == 'textarea'}
    <textarea class="form-control {classname}" bind:value={nameval} {placeholder} {rows} />
    {:else if type == 'date'}
    <input type='date' class="form-control {classname}" bind:value={nameval} />
    {:else if istext}
    <input type='text' class="form-control {classname}" bind:value={nameval} {placeholder} />
    {:else if type=='dropdown'}

    <select class={tlClass ? "select caret" : "form-control {classname}" } bind:value={selected} on:change={onSelect}>
        <option value="">{placeholder}</option>
        {#each options as opt}
        <option value={opt.value}>
            <!-- {helpers.capitalize(opt.text)} -->
            {opt.text}
        </option>
        {/each}
    </select>
    {:else}
    <input class="form-control " type='text' bind:value={nameval} {placeholder} />
    {/if}

    <!-- {JSON.stringify(errors[nameval])} -->

    {#if error && error !== ''}
    <small class="error">{error}</small>
    {/if}
</div>
&nbsp;